import SideSheetModal from "@/components/SideSheetModal";
import { ColumnSort } from "@tanstack/react-table";
import Icon from "@/components/Icon";
import Button from "@/components/Button";

interface SortOption {
  id: string;
  label: string;
  desc: boolean;
  display: string;
}

interface MobileSortDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  onSortChange: (sort: ColumnSort[]) => void;
  currentSort: ColumnSort[];
}

const sortOptions: SortOption[] = [
  { id: "title", label: "Job Title", desc: false, display: "A to Z" },
  { id: "title", label: "Job Title", desc: true, display: "Z to A" },
  { id: "facility", label: "Facility", desc: false, display: "A to Z" },
  { id: "facility", label: "Facility", desc: true, display: "Z to A" },
  { id: "employer", label: "Employer", desc: false, display: "A to Z" },
  { id: "employer", label: "Employer", desc: true, display: "Z to A" },
  { id: "totalCompensation", label: "Compensation", desc: true, display: "High to Low" },
  { id: "totalCompensation", label: "Compensation", desc: false, display: "Low to High" },
  { id: "goLiveTime", label: "Posted Date", desc: true, display: "New to Old" },
  { id: "goLiveTime", label: "Posted Date", desc: false, display: "Old to New" },
  { id: "submissionDeadline", label: "Deadline", desc: true, display: "Latest to Earliest" },
  { id: "submissionDeadline", label: "Deadline", desc: false, display: "Earliest to Latest" },
  { id: "applicantCount", label: "Applicants", desc: true, display: "Most to Least" },
  { id: "applicantCount", label: "Applicants", desc: false, display: "Least to Most" }
];

export default function MobileSortDrawer({ isOpen, onClose, onSortChange, currentSort }: MobileSortDrawerProps) {
  const handleSortSelect = (option: SortOption) => {
    onSortChange([{ id: option.id, desc: option.desc }]);
    onClose();
  };

  const isCurrentSort = (option: SortOption) => {
    return currentSort.length > 0 && currentSort[0].id === option.id && currentSort[0].desc === option.desc;
  };

  const handleSidebarChange = (open: boolean) => {
    if (!open) {
      onClose();
    }
  };

  return (
    <SideSheetModal
      isSidebarOpen={isOpen}
      setSidebarOpen={handleSidebarChange}
      title="Sort Table By"
      disableFocusManagement={true}
      actions={
        <Button variant="filled" onClick={onClose}>
          Close
        </Button>
      }
    >
      <div className="space-y-0 mt-4">
        {sortOptions.map((option) => (
          <button
            key={`${option.id}-${option.desc}`}
            onClick={() => handleSortSelect(option)}
            className="w-full flex items-center justify-between py-4 text-left hover:bg-sys-brand-surface-container transition-colors border-b border-sys-brand-surface-container-high last:border-b-0"
          >
            <div className="flex flex-col">
              <span className="text-base font-medium text-sys-brand-on-surface">{option.label}</span>
              <span className="text-sm text-gray-500">{option.display}</span>
            </div>
            {isCurrentSort(option) && <Icon name="check" className="text-blue-600 ml-3" />}
          </button>
        ))}
      </div>
    </SideSheetModal>
  );
}
